import { useEffect, useMemo, useRef, useState } from 'react';
import './Dashboard.css';

const TV_SCRIPT_SRC = 'https://s3.tradingview.com/tv.js';

let tvScriptPromise = null;

// Binance interval -> TradingView widget resolution.
const INTERVAL_MAP = {
    '1m': '1',
    '3m': '3',
    '5m': '5',
    '15m': '15',
    '30m': '30',
    '1h': '60',
    '2h': '120',
    '4h': '240',
    '6h': '360',
    '8h': '480',
    '12h': '720',
    '1d': 'D',
    '3d': '3D',
    '1w': 'W',
    '1M': 'M',
};

function loadTradingView() {
    if (window.TradingView) return Promise.resolve();
    if (tvScriptPromise) return tvScriptPromise;
    tvScriptPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = TV_SCRIPT_SRC;
        script.async = true;
        script.onload = () => resolve();
        script.onerror = () => {
            tvScriptPromise = null;
            script.remove();
            reject(new Error('Failed to load TradingView script'));
        };
        document.body.appendChild(script);
    });
    return tvScriptPromise;
}

/**
 * props:
 * - symbol
 * - interval (Binance style, e.g. '1m'; defaults to 1m)
 * - indicators (TradingView studies; defaults to the RSI)
 */
const DEFAULT_INDICATORS = ['RSI@tv-basicstudies'];

function CandleChart(props) {
    const [failed, setFailed] = useState(false);
    const widgetRef = useRef(null);

    useEffect(() => {
        let cancelled = false;
        setFailed(false);
        loadTradingView()
            .then(() => {
                if (cancelled || !window.TradingView) return;
                const container = document.getElementById('tradingview_atb');
                if (container) container.innerHTML = '';
                widgetRef.current = new window.TradingView.widget({
                    symbol: 'BINANCE:' + props.symbol,
                    autosize: true,
                    interval: INTERVAL_MAP[props.interval] || '1',
                    timezone: 'Etc/UTC',
                    theme: 'dark',
                    style: '1',
                    locale: 'en',
                    toolbar_bg: '#f1f3f6',
                    enable_publishing: false,
                    allow_symbol_change: false,
                    details: true,
                    withdateranges: true,
                    hide_side_toolbar: false,
                    studies: props.indicators || DEFAULT_INDICATORS,
                    container_id: 'tradingview_atb',
                });
            })
            .catch(() => {
                if (!cancelled) setFailed(true);
            });
        return () => {
            cancelled = true;
        };
    }, [props.symbol, props.interval, props.indicators]);

    const widgetHtml = useMemo(() => {
        return (
            <div className="row">
                <div className="col-12 mb-4">
                    <div
                        className="card cardDark border-0 shadow"
                        style={{ height: 520 }}
                    >
                        <div className="card-body p-2">
                            {failed ? (
                                <div className="d-flex h-100 align-items-center justify-content-center">
                                    <p className="text-muted mb-0">
                                        Unable to load the TradingView chart.
                                        Check your connection or disable content
                                        blockers for this page.
                                    </p>
                                </div>
                            ) : (
                                <div className="tradingview-widget-container ">
                                    <div
                                        id="tradingview_atb"
                                        className="divTradingView"
                                    ></div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }, [failed]);

    return widgetHtml;
}

export default CandleChart;
